var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "panel panel-default" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "panel-body" }, [
      _c("p", [
        _vm._v(
          'Edit your caption, click "Copy to clipboard" to store the text, and then paste it into your Instagram post\'s caption block.'
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "" } }, [_vm._v("Caption:")]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.caption,
              expression: "caption",
            },
          ],
          staticClass: "form-control",
          attrs: { id: "", rows: "3" },
          domProps: { value: _vm.caption },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.caption = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showCopyToClipboard,
              expression: "showCopyToClipboard",
            },
          ],
          staticClass: "btn btn-link pull-right text-right clipboard-popover",
          attrs: { type: "button" },
          on: { click: _vm.copyCaptionClick },
        },
        [_vm._v("Copy to Clipboard")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h3", { staticClass: "panel-title" }, [
        _vm._v("2. Create Your Caption"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }